import { unified } from "unified";
import remarkParse from "remark-parse";
import remarkGfm from "remark-gfm";

interface PreviewNode {
  type: string;
  value?: string;
  alt?: string | null;
  children?: PreviewNode[];
}

const parser = unified().use(remarkParse).use(remarkGfm);

/** Extracts readable task text without Markdown syntax or link destinations. */
export function getTaskDescriptionPreview(description: string): string {
  return nodeText(parser.parse(description)).replace(/\s+/g, " ").trim();
}

function nodeText(node: PreviewNode): string {
  if (node.type === "html") {
    return "";
  }
  if (node.type === "break") {
    return " ";
  }
  if (node.type === "image" || node.type === "imageReference") {
    return node.alt ?? "";
  }
  if (node.value !== undefined) {
    return node.value;
  }
  let separator = "";
  if (
    ["root", "blockquote", "list", "listItem", "table", "tableRow"].includes(
      node.type,
    )
  ) {
    separator = " ";
  }
  return node.children?.map(nodeText).join(separator) ?? "";
}
